module.exports = __webpack_public_path__ + "media/images/hero-1-7464cba2.jpg";